import React from "react";
import UserEditForm from "../forms/UserEditForm";
import { CardActions, Chip, Container, Flex, Card, CardHeader, CardContent, Spinner} from "@airbus/components-react";
import { Delete, Edit } from "@airbus/icons/react";
import eventBus from "../eventBus/EventBus";
import ModalMessageBox from "../components/ModalMessageBox";






//CONTROLLER
import { UserController } from "../controller/UserController";



class UsersView extends React.Component {

    constructor(props){
        super(props);


        //States
        this.state={
            users : [],           //List of users from API
            useredit : null,      //Edited user
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
            openModal: false,
            spinner: true,
        }

       
       //Notification params
       this.setNotification=this.props.notificationHandler;  //call parent notification handler


       //Modal Box
       this.title = null;
       this.message = null;
       this.description = null;
       this.onConfirmCallback = null;
       this.onCancelCallback = null;


    }


    /*Handle screen size*/
    handleResize = (e) => {
      this.setState({ 
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight
      });

    };

    
    async componentDidMount() {
        

        //Manage screen size
        window.addEventListener("resize", this.handleResize);

        //Retrieve Users
        await this.getUsers();     
        
        //Listener Go back to list view after submit update User
        eventBus.on("listview", (data) => {          
          if(data['listview'] === true){
            this.getUsers();
            this.setState({ useredit: null }) //set state to go back to list view

            //Display success banner
            this.setNotification(true,{
              notifVariant: "success",
              notifMessage:"L'utilisateur a été modifié avec succès",
              notifDescription:null
            });

          }  

      });

      this.setState({spinner: false});

    }


    componentWillUnmount() {
      //Manage screen size
      window.addEventListener("resize", this.handleResize);

    }

    /**
     * RENDERING
     * @returns dom
     */
    render() { return(
        <Container style={{height:this.state.windowHeight-150, paddingTop:'10px'}}>
                    
            

            {/**SPINNER WAIT */}
            {this.state.spinner &&
            <Flex justify="left"style={{paddingTop:"25px"}}>
                <Spinner dots/>
            </Flex>
            }

            {/* HANDLE MODAL BOX */}
            
            <ModalMessageBox 
                title={this.title}
                message={this.message}
                description={this.description}
                open={this.state.openModal}
                onConfirmCallback={this.onConfirmCallback}
                onCancelCallback={this.onCancelCallback}

            />

            {/* USERS DISPLAY */}
            {!this.state.useredit && !this.state.spinner ?
              <div>
              
              <Container until='xl'>
              <Flex wrap justify='left' spacing='2-x'>
                
              {this.state.users.map((key, i)=>(
                
                <Card 
                    style={{width:'300px', height:'200px'}}
                    key={'card-'+i}     
                    translate        
                >
                  <CardHeader
                      title={key.name+' '+key.firstname}
                      key = {'header-'+i}
                  />
                  <CardContent>
                      <p>
                          <b>login: </b>{key.login}
                      </p>
                      <p>
                          <b>mail: </b>{key.mail}
                      </p>
                      <p>
                          <b>role: </b>{key.role}
                      </p>
                      
                  </CardContent>
                  <CardActions>
                  <Chip
                      label=""
                      icon={<Edit />}
                      clickable
                      variant={"warning"}
                      onClick={() =>{this.onModifyUserClick(key.id)}}
                  />

                  <Chip
                      label=""
                      icon={<Delete />}
                      clickable
                      variant={"error"}
                      onClick={() =>{this.onDeleteUserClick(key.id, key.name+' '+key.firstname)}}
                  />
                    
                    
                  </CardActions>
                </Card>

              ))};
                  
              </Flex>
              </Container>

              </div>

            :null}

            {/* EDIT USER DISPLAY */}
            {this.state.useredit ?
              <UserEditForm id={this.state.useredit.id}
                            username={this.state.useredit.login}
                            password={this.state.useredit.password}
                            role={this.state.useredit.role}
                            lastname={this.state.useredit.name}
                            mail={this.state.useredit.mail}
                            firstname={this.state.useredit.firstname}
                            notificationHandler={this.setNotification}

                            />
            :null}
        </Container>
    )}
    

    /*
     * FUNCTIONS 
     */
    
    //get user list
    getUsers= async() => {
        
        try{
            const response = await new UserController().getUsers();

            if (response === undefined){

              //erreur API call
              this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"API erreur: Erreur lors de la récupération des données",
                notifDescription:null
              });

            }
            else if (response.response === "200"){
                this.setState({users: response.dataArray});
            }
            else{
                this.setState({users: [] });

                //API return <> 200
                this.setNotification(true,{
                  notifVariant: "error",
                  notifMessage:"Erreur lors de la récupération des données",
                  notifDescription:response.response+": "+response.responseDescription
                });

            }
        }
        catch(err){
            console.log(err);
        }
        
    }

    //delete user 
    deleteUser = async(id) =>{
      try{
        const response = await new UserController().deleteUser(id);

        if (response === undefined){
          //Fire notification
          this.setNotification(true,{
            notifVariant: "error",
            notifMessage: "API Erreur: l'utilisateur n'a pas pu être supprimé",
            notifDescription:null
          });

        }
        else if (response.response === "200"){
            
          //Fire notification
          this.setNotification(true,{
            notifVariant: "success",
            notifMessage: "Utilisateur supprimé avec succès",
            notifDescription:null
          });

        }
        else{
            this.setState({users: [] });

            //Fire notification
            this.setNotification(true,{
              notifVariant: "error",
              notifMessage: "Erreur lors de la suprresion du compte",
              notifDescription:response.response+": "+response.responseDescription
            });           

        }
      }
    catch(err){
        console.log(err);
      }
    }


    //get user by id
    getUserById = async(id) =>{
      try{
  
        const response = await new UserController().getUserByID(id);
        
        if (response === undefined){
          //Fire notification
          this.setNotification(true,{
            notifVariant: "error",
            notifMessage: "API Erreur: Impossible de récupérer les informations utilisateur",
            notifDescription:null
          }); 

          return null
        }
        else if (response.response === "200"){
 
          return await response.dataArray;

        }
        else{
            this.setState({users: [] });

            //Fire notification
            this.setNotification(true,{
              notifVariant: "error",
              notifMessage: "Erreur lors de la récupération du compte utilisateur",
              notifDescription:response.response+": "+response.responseDescription
            }); 
            
            return null;

        }
      }
      catch(err){
          console.log(err);
      }
    }


    /****
     * EVENTS
     * */
    
    //On click "modifier"
    onModifyUserClick = async (e) => {
      

      let selectedId =  e;

      //Get User data to edit
      let userData = await this.getUserById(selectedId);
      
      //Fire Edition form by changing state
      this.setState({useredit:userData});


      

    }


    
     //On click "delete"
     onDeleteUserClick = (id, name) => {

      this.title="Suppression";
      this.message="L'utilisateur "+name+" ne pourra plus accéder à cette application. Cette action est irréversible. Voulez-vous continuer ?";
      this.description=null;
      this.onConfirmCallback=this.onConfirmUserDelete.bind(this, id);
      this.onCancelCallback=()=>{this.setState({openModal:false})}
      this.setState({openModal:true});


    }


    /**
     * On user confirm deletion
     * @param {number} id user id
     */
    onConfirmUserDelete = (id)=>{

      let selectedId =  id;
      this.deleteUser(selectedId);
      this.getUsers();

      this.setState({openModal:false}); //close modal

    }


}

export default UsersView;